import { gql } from '@apollo/client'
import { smallProductFragment } from 'Fragments'

const GET_PRODUCTS = gql`
  query products(
    $arguments: GetProducts!
    $pagination: Pagination!
    $sort: SortProducts!
  ) {
    products(arguments: $arguments, pagination: $pagination, sort: $sort) {
      _cache
      products {
        ...smallProduct
      }
      categories {
        children {
          uuid
          name
          slug
        }
        current {
          filters {
            values {
              name
            }
          }
          uuid
          name
          slug
        }
        top {
          uuid
          name
          slug
        }
      }
      aggregations {
        stores {
          name
          id
        }
        prices {
          min
          max
        }
        departments {
          count
          name
        }
        sales
        count
      }
      pagination {
        previous
        next
        pages
      }
    }
  }

  ${smallProductFragment}
`

export default GET_PRODUCTS
